// extracted by mini-css-extract-plugin
module.exports = {"socialLogin":"styles__socialLogin___22g1r","loginFooter":"styles__loginFooter___Dt6DK","loginForm":"styles__loginForm___fXtEX"};